/**
 * @fileoverview GET handler for the "/apps/app_groups" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { getAppGroupsCacheKey } from "./constants";
import type { GetAppGroupsResult } from "./types";

export const getAppGroups = reactQueryFetcherAdapter(
  getAppGroupsCacheKey,
  (signal: AbortSignal): Promise<GetAppGroupsResult> => {
    return fetch("/apps/app_groups", "GET", undefined, { signal });
  }
);
